<template>
    <div>
        <breadcrumbs class="mb-3" />
        <page-title :text="$t('page_titles.venues_page_title')" />
        <VenuesTable
            ref="table"
            location-type="venue"
            allow-edit
            :items="items"
            allow-create
            :is-loading="isLoading"
            @load-locations="load"
        >
            <template v-slot:filters>
                <LocationsFilters
                    v-model="filters"
                    :has-active-filters="hasActiveFilters"
                    location-type="venue"
                    @reset="resetFilters"
                    @submit="load"
                />
            </template>
        </VenuesTable>
    </div>
</template>

<script setup lang="ts">
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import VenuesTable from '~/components/account/locations/VenuesTable.vue'
    import {initLocationsFilters} from '~/utils/types/account/locations/helpers'
    import type {LocationsFiltersType} from '~/utils/types/account/locations/types'
    import LocationsFilters from '~/components/account/locations/LocationsFilters.vue'
    import PageTitle from '@/components/parts/PageTitle.vue'
    import {isEqual} from '~/utils/helpers'

    const app = useNuxtApp()

    const filters = ref<LocationsFiltersType>(initLocationsFilters())
    const isLoading = ref<boolean>(false)
    const items = ref<any[]>([])

    onMounted(async () => {
        await load()
    })

    function resetFilters(): void {
        filters.value = initLocationsFilters()
        load()
    }

    async function load(): Promise<void> {
        try {
            isLoading.value = true
            const {eventVenues} = await app.$api.venues.get({
                active: filters.value.active,
                ...(filters.value.name && {name: filters.value.name}),
                ...(filters.value.city?.id && {cityId: filters.value.city.id}),
                locale: 'all',
                limit: 100,
            })

            items.value = eventVenues
        } catch (e) {
            console.error(e)
        } finally {
            isLoading.value = false
        }
    }

    const hasActiveFilters: ComputedRef<boolean> = computed(() => !isEqual(initLocationsFilters(), filters.value))

    const table = ref(null)
</script>
